
// import { Nav, Dropdown, Row, Col } from 'react-bootstrap';
// import { Link, useLocation } from 'react-router-dom';
// import classNames from 'classnames';
// import { sendVisitLog } from 'helpers/visitLogger';

// type MenuProps = {
//     showDownload?: boolean;
//     navClass?: string;
//     buttonClass?: string;
//     loggedInUser?: {};
//     activeSection?: string;
//     BlogPage?: boolean;
// };

// const Menu = ({ navClass, buttonClass, showDownload, loggedInUser, activeSection, BlogPage }: MenuProps) => {
//     const location = useLocation();

//     const isActive = (path: string) => location.pathname === path;


//     return (
//         <Nav as="ul" className={classNames('align-items-lg-center', navClass)}>

//             <Nav.Item as="li">
//                 {BlogPage ? (
//                     // <Link
//                     //     to="/"
//                     //     className="nav-link"
//                     //     onClick={() => sendVisitLog("/")}
//                     // >
//                     //     Home
//                     // </Link>


//                     <Link
//                         to="/"
//                         className={classNames("nav-link", { active: isActive("/") })}
//                         onClick={() => sendVisitLog("/")}
//                     >
//                         Home
//                     </Link>
//                 ) : (
//                     <a
//                         href="/"
//                         // className={classNames("nav-link", { active: activeSection === "home" })}
//                         className={classNames("nav-link", { active: isActive("/") })}
//                         onClick={() => sendVisitLog("/")}
//                     >
//                         Home
//                     </a>
//                 )}
//             </Nav.Item>

//             <Nav.Item as="li">
//                 {BlogPage ? (
//                     <Link
//                         to="/features"
//                         className="nav-link"
//                         onClick={() => sendVisitLog("/features")}
//                     >
//                         Features
//                     </Link>
//                 ) : (
//                     <a
//                         href="features"
//                         // className={classNames("nav-link", { active: activeSection === "features" })}
//                         className={classNames("nav-link", { active: isActive("/features") })}
//                         onClick={() => sendVisitLog("/features")}
//                     >
//                         Features
//                     </a>
//                 )}
//             </Nav.Item>

//             <Nav.Item as="li">
//                 {BlogPage ? (
//                     <Link
//                         to="/about"
//                         className="nav-link"
//                         onClick={() => sendVisitLog("/about")}
//                     >
//                         About
//                     </Link>
//                 ) : (
//                     <a
//                         href="about"
//                         className={classNames("nav-link", { active: activeSection === "about" })}
//                         onClick={() => sendVisitLog("/about")}
//                     >
//                         About
//                     </a>
//                 )}
//             </Nav.Item>

//             <Nav.Item as="li">
//                 {BlogPage ? (
//                     <Link
//                         to="/contact"
//                         className="nav-link"
//                         onClick={() => sendVisitLog("/contact")}
//                     >
//                         Contact
//                     </Link>
//                 ) : (
//                     <a
//                         href="contact"
//                         className={classNames("nav-link", { active: activeSection === "contact" })}
//                         onClick={() => sendVisitLog("/contact")}
//                     >
//                         Contact
//                     </a>
//                 )}
//             </Nav.Item>


//             <Nav.Item as="li">
//                 {BlogPage ? (
//                     <Link
//                         to="/blogs"
//                         className="nav-link"
//                         onClick={() => sendVisitLog("/blogs")}
//                     >
//                         Blogs
//                     </Link>
//                 ) : (
//                     <a
//                         href="blogs"
//                         className={classNames("nav-link", { active: activeSection === "blogs" })}
//                         onClick={() => sendVisitLog("/blogs")}
//                     >
//                         Blogs
//                     </a>
//                 )}
//             </Nav.Item>


//             {showDownload && (
//                 <>
//                     {loggedInUser ? (
//                         <Nav.Item as="li">  <Link to="/auth/logout" className="nav-link btn me-2 shadow-none">   Logout</Link> </Nav.Item>
//                     ) : null}

//                     <a href="contact" className="btn btn-primary rounded-pill">
//                         Request a Demo
//                     </a>
//                 </>
//             )}
//         </Nav>
//     );
// };

// export default Menu;



import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { sendVisitLog } from 'helpers/visitLogger';

type MenuProps = {
    showDownload?: boolean;
    navClass?: string;
    buttonClass?: string;
    loggedInUser?: {};
    BlogPage?: boolean;
};

const Menu = ({ navClass, buttonClass, showDownload, loggedInUser, BlogPage }: MenuProps) => {
    const location = useLocation();

    // const isActive = (path: string) => {
    //     if (path === "/") return location.pathname === "/";
    //     return location.pathname.startsWith(path);
    // };


    const isActive = (path: string) => {
        if (path === "/") return location.pathname === "/";

        // Blogs: /blogs and /blog/*
        if (path === "/blogs") {
            return (
                location.pathname === "/blogs" ||
                location.pathname.startsWith("/blog/")
            );
        }

        return location.pathname.startsWith(path);
    };


    return (
        <Nav as="ul" className={classNames('align-items-lg-center', navClass)}>

            {/* Home */}
            <Nav.Item as="li">
                <Link
                    to="/"
                    className={classNames("nav-link", { active: isActive("/") })}
                    onClick={() => sendVisitLog("/")}
                >
                    Home
                </Link>
            </Nav.Item>

            {/* Features */}
            <Nav.Item as="li">
                <Link
                    to="/features"
                    className={classNames("nav-link", { active: isActive("/features") })}
                    onClick={() => sendVisitLog("/features")}
                >
                    Features
                </Link>
            </Nav.Item>

            {/* About */}
            <Nav.Item as="li">
                <Link
                    to="/about"
                    className={classNames("nav-link", { active: isActive("/about") })}
                    onClick={() => sendVisitLog("/about")}
                >
                    About
                </Link>
            </Nav.Item>

            {/* Contact */}
            <Nav.Item as="li">
                <Link
                    to="/contact"
                    className={classNames("nav-link", { active: isActive("/contact") })}
                    onClick={() => sendVisitLog("/contact")}
                >
                    Contact
                </Link>
            </Nav.Item>

            {/* Blogs */}
            {/* <Nav.Item as="li">
                <Link
                    to="/blogs"
                    className={classNames("nav-link", {
                        active: isActive("/blogs"),
                    })}
                    onClick={() => sendVisitLog("/blogs")}
                >
                    Blogs
                </Link>
            </Nav.Item> */}
            <Nav.Item as="li">
                <Link
                    to="/blogs"
                    className={classNames("nav-link", {
                        active: isActive("/blogs"),
                    })}
                    onClick={() => sendVisitLog("/blogs")}
                >
                    Blogs
                </Link>
            </Nav.Item>


            {/* Right Side Buttons */}
            {showDownload && (
                <>
                    {loggedInUser && (
                        <Nav.Item as="li">
                            <Link to="/auth/logout" className="nav-link btn me-2 shadow-none">
                                Logout
                            </Link>
                        </Nav.Item>
                    )}

                    <Nav.Item as="li">
                        <Link to="/contact" className="btn btn-primary rounded-pill">
                            Request a Demo
                        </Link>
                    </Nav.Item>
                </>
            )}
        </Nav>
    );
};

export default Menu;
